/**
 * Οθόνες αφής στα Windows: το παρατεταμένο άγγιγμα είναι «δεξί κλικ». Ο browser ανοίγει το μενού του
 * πάνω από το ταμείο (αναφορά καταστήματος 15/10/2026: «όταν κρατάνε πατημένο ένα προϊόν ανοίγει τις
 * επιλογές των Windows»). Το κράτημα όμως είναι δική μας κίνηση: σε προϊόν ανοίγει την προσαρμογή,
 * σε γραμμή καλαθιού την επιλογή, στο «Μετρητά» την εκπαίδευση.
 *
 * Κόβουμε το μενού ΜΟΝΟ όταν έρχεται από αφή ή γραφίδα, και ποτέ μέσα σε πεδίο κειμένου, όπου
 * χρειάζεται για επικόλληση. Το δεξί κλικ του ποντικιού μένει όπως ήταν.
 */
const EDITABLE = 'input, textarea, select, [contenteditable="true"], [contenteditable=""]';

export function installTouchContextMenuGuard(doc: Document = document): () => void {
  // Το contextmenu του Chrome είναι PointerEvent με pointerType· για παλιότερους browsers κρατάμε
  // το είδος του τελευταίου πατήματος.
  let lastPointerType = '';
  const onPointerDown = (e: PointerEvent) => { lastPointerType = e.pointerType || ''; };
  const onContextMenu = (e: MouseEvent) => {
    const type = (e as PointerEvent).pointerType || lastPointerType;
    if (type !== 'touch' && type !== 'pen') return;
    const target = e.target as Element | null;
    if (target && typeof target.closest === 'function' && target.closest(EDITABLE)) return;
    e.preventDefault();
  };
  doc.addEventListener('pointerdown', onPointerDown, true);
  doc.addEventListener('contextmenu', onContextMenu, true);
  return () => {
    doc.removeEventListener('pointerdown', onPointerDown, true);
    doc.removeEventListener('contextmenu', onContextMenu, true);
  };
}
